export default "__VITE_ASSET__BqQSFAGN__"